import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum SeoStrategyStatus {
  Success = 'success',
  Pending = 'pending',
  Error = 'error',
}

export const seoStrategyCreateSchema = z.object({
  brandId: z.string(),
  organizationId: z.string(),

  country: z
    .string()
    .regex(/^[A-Za-z]{2}$/, 'INVALID_COUNTRY')
    .nullish(),
  language: z
    .string()
    .regex(/^[A-Za-z]{2}$/, 'INVALID_LANGUAGE')
    .nullish(),
  websiteUrl: z.string().nullish(),
  competitorsUrls: z.array(z.string()),
  pagesPerMonth: z.number(),

  status: z.nativeEnum(SeoStrategyStatus),

  // company descriptors
  productsServices: z.string(),
  problemsSolved: z.string(),
  faqSales: z.string(),
  purchaseBarriers: z.string(),
  additionalNotes: z.string(),

  // response from the ai
  sumOverview: z.string(),
  sumStrengths: z.array(z.string()),
  sumOpportunities: z.array(z.string()),
  sumWeaknesses: z.array(z.string()),
});
export type SeoStrategyCreate = z.infer<typeof seoStrategyCreateSchema>;

export const seoStrategySchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(seoStrategyCreateSchema);

export type SeoStrategy = z.infer<typeof seoStrategySchema>;
